import { AutocompleteChangeReason, TextField } from "@mui/material";
import { Input } from "components/Form/components/Input/Input";
import { RoleSelectAutocomplete } from "components/RoleSelect/RoleSelectAutocomplete";
import { Field } from "react-final-form";

interface RoleSelectAutocompleteFormComponentProps {
    name: string;
    roleOptions: any;
    defaultValue?: any;
    initialValue?: any;
}

export const RoleSelectAutocompleteFormComponent = ({
    name,
    roleOptions,
    defaultValue,
    initialValue,
}: RoleSelectAutocompleteFormComponentProps) => {
    return (
        <Field
            name={name}
            id={name}
            fieldProps={{
                label: "Roles",
                options: roleOptions,
                defaultValue,
                columnDirection: true,
            }}
            initialValue={initialValue}
        >
            {({ input, fieldProps, fieldAttr, meta }) => {
                return (
                    <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
                        <RoleSelectAutocomplete
                            options={fieldProps.options}
                            selectedValue={input.value}
                            renderInput={(params) => <TextField {...params} />}
                            onDelete={(e, val) => {
                                e.preventDefault();
                                const filteredValues = input.value.filter(
                                    (value) => value.id !== val.id
                                );
                                input.onChange(filteredValues);
                            }}
                            onPropagateChange={(event, val) => {
                                const mappedValues = input.value.map((value) => {
                                    if (value.id === val.id) {
                                        return {
                                            ...value,
                                            propagate: event.target.checked,
                                        };
                                    }
                                    return value;
                                });
                                input.onChange(mappedValues);
                            }}
                            onAddRole={(
                                event: React.SyntheticEvent,
                                value: any[],
                                reason: AutocompleteChangeReason
                            ) => {
                                if (reason === "selectOption") {
                                    const addedRole = !input.value.some(
                                        (v) => v.id === value[value.length - 1].id
                                    );

                                    if (addedRole) {
                                        input.onChange(value);
                                    }
                                }
                            }}
                            disablePortal={true}
                        />
                    </Input>
                );
            }}
        </Field>
    );
};
